<!--
 * @Author: your name
 * @Date: 2021-04-21 14:13:18
 * @LastEditTime: 2021-04-21 14:50:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\views\withdrawal.vue
-->

<template>
  <div class="withdrawal">
    <div class="withdrawal-main">
      <div class="flex">
        <img class="bank-logo" :src="imgPath+'icon_yinhangka.png'" alt />
        <div>
          <div class="bank-name" v-if="myWalletInfo.bank">{{myWalletInfo.bank.bank_name}}</div>
          <div class="bank-title">尾号{{bankNo}}储蓄卡</div>
        </div>
      </div>
      <div class="tips">提现金额</div>
      <div class="price flex">
        <div class="icon">¥</div>
        <van-field v-model="accontnum" type="number" placeholder="输入提现金额" />
        <!-- <input v-model="accontnum" type="number" placeholder="输入提现金额" /> -->
      </div>
      <div class="balance-tips">
        <div>账户余额：{{myWalletInfo.amount}}元</div>
        <!--        <div class="flex">-->
        <!--          <div>今日剩余提现金额2000元</div>-->
        <!--          <div class="link">详情</div>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="withdrawal-tips">提现金额不能小于1元，提现费用1元/笔</div>
    <div class="with-btn" @click="submit">提交申请</div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
export default {
  data() {
    return {
      accontnum: '',
      myWalletInfo: {}, //基本信息
      bankNo: '',
    }
  },
  mounted() {
    this.prohibitweixinShare()
    console.log(this.accontnum)
  },
  created() {
    this.getMyWalletInfo()
  },
  methods: {
    //获取钱包信息
    getMyWalletInfo() {
      this.http('Client.myWalletInfo', {}).then((res) => {
        if (res.status == 200) {
          console.log(res)
          // withdraw_is_code
          this.myWalletInfo = res.content
          var bank_cardno = res.content.bank.bank_card_no
          this.bankNo = bank_cardno.substring(bank_cardno.length - 4) //截取后四位卡号
        } else {
          Toast(res.msg)
        }
      })
    },

    //提交申请
    submit() {
      // if (this.accontnum < 1) {
      //   Toast('提现金额不能小于1元~')
      //   return
      // } else if (this.accontnum > this.myWalletInfo.amount) {
      //   Toast('当前提现金额不可大于' + this.myWalletInfo.amount + '元~')
      //   return
      // }
      this.http('MemberAuth.applyWithdraw', {
        bank_id: this.myWalletInfo.bank.id,
        amount: this.accontnum,
      }).then((res) => {
        if (res.status == 200) {
          console.log(res)
          Toast('提交申请成功~')
          setTimeout(() => {
            this.$router.push({ path: '/wallet' })
          }, 3000)
        } else {
          Toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.withdrawal {
  width: 100vw;
  min-height: 100vh;
  background: #f8f8f8;
  overflow: hidden;
  .withdrawal-main {
    width: 710px;
    height: 470px;
    background: #ffffff;
    margin: 20px auto 0;
    padding: 44px 32px;
    box-sizing: border-box;
    border-radius: 14px;
    .bank-logo {
      width: 80px;
      height: 80px;
      margin-right: 32px;
    }
    .bank-name {
      font-size: 30px;
      font-weight: 500;
      color: #333333;
      line-height: 30px;
      margin-top: 10px;
    }
    .bank-title {
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      line-height: 24px;
      margin-top: 10px;
    }
    .tips {
      margin-top: 60px;
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
    }

    .price {
      margin-top: 52px;
      border-bottom: 2px solid #f2f2f2;
      padding-bottom: 20px;
      .icon {
        font-size: 28px;
        font-weight: 500;
        color: #333333;
        line-height: 52px;
        margin-right: 18px;
        padding-top: 15px;
      }
      input {
        font-size: 48px;
        font-weight: 600;
        color: #333333;
        line-height: 48px;
      }
      input::placeholder {
        font-size: 48px;
        font-weight: 500;
        color: #cdcdcd;
        line-height: 48px;
      }
    }

    .balance-tips {
      font-size: 26px;
      font-weight: 400;
      color: #999999;
      line-height: 26px;
      margin-top: 30px;
      > div {
        margin-top: 15px;
      }
      .link {
        color: #4983ff;
        text-decoration: underline;
        margin-left: 16px;
      }
    }
  }
  .withdrawal-tips {
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    text-indent: 32px;
    margin-top: 20px;
  }
  .with-btn {
    width: 686px;
    height: 96px;
    background: #ee0a24;
    border-radius: 48px;
    margin: 80px auto;
    display: block;
    font-size: 28px;
    font-weight: 400;
    color: #ffffff;
    line-height: 96px;
    text-align: center;
  }
}
</style>